<template>
  <div class="massege-empty-folder">
    <span>{{messages}}</span>
  </div>
</template>

<script>
export default {
  props: ["messages"]
};
</script>

<style lang="scss" scoped>
</style>